import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './backdrop.module.scss';

const Backdrop = ({ onCancel, elevated }) => (
  <div
    className={cn(styles.backdrop, elevated && styles.elevated)}
    onClick={onCancel}
    aria-hidden="true"
  />
);

Backdrop.propTypes = {
  onCancel: PropTypes.func.isRequired,
  elevated: PropTypes.bool,
};

Backdrop.defaultProps = {
  elevated: false,
};

export default Backdrop;
